import { theme } from 'antd';
import { APP_BRAND_THEME } from './brandTheme';

// Paint only the exposed canvas; page controls retain their own theme context.
// Resolve lazily: consumers of the appearance preference alone need no palette.
const backgrounds = [];
export function canvasBackground(isDark) {
  const index = Number(isDark);
  if (!backgrounds[index]) backgrounds[index] = theme.getDesignToken({
    ...APP_BRAND_THEME,
    algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
  }).colorBgLayout;
  return backgrounds[index];
}
